import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { cn } from '@/shared/lib/cn';

/** Galaxy Collapsible — Radix-backed expand/collapse. Prefer over hand-rolled aria-expanded. */

export const Collapsible = CollapsiblePrimitive.Root;

export const CollapsibleTrigger = forwardRef<
  ElementRef<typeof CollapsiblePrimitive.CollapsibleTrigger>,
  ComponentPropsWithoutRef<typeof CollapsiblePrimitive.CollapsibleTrigger>
>(function CollapsibleTrigger({ className, ...props }, ref) {
  return (
    <CollapsiblePrimitive.CollapsibleTrigger
      ref={ref}
      className={cn(
        'cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-focus-ring)]',
        className,
      )}
      {...props}
    />
  );
});

export const CollapsibleContent = forwardRef<
  ElementRef<typeof CollapsiblePrimitive.CollapsibleContent>,
  ComponentPropsWithoutRef<typeof CollapsiblePrimitive.CollapsibleContent>
>(function CollapsibleContent({ className, ...props }, ref) {
  return (
    <CollapsiblePrimitive.CollapsibleContent
      ref={ref}
      className={cn('overflow-hidden', className)}
      {...props}
    />
  );
});
